<template>
  <p class="emd-text eu-mt_1">
    {{ $t('keys.description') }}
    <a
      target="_blank"
      rel="noopener"
      class="emd-text _color_primary _type_caption"
      href="https://docs.pagar.me/docs/chaves-de-acesso"
    >
      {{ $t('keys.description-anchor') }}
    </a>
  </p>
</template>

<script>
export default {
  name: 'DocKey'
}
</script>

<i18n>
  {
    "pt-BR": {
      "keys": {
        "description": "As chaves de API são responsáveis pela sua integração com o Pagar.me e por associar as transações do seu site à sua conta.",
        "description-anchor": "Acesse nossa documentação para saber mais."
      }
    },
    "en-US": {
      "keys": {
        "description": "The API keys are responsible for your integration with the Pagar.me and for associatin transactions of your website with your account.",
        "description-anchor": "Visit our documentation to learn more"
      }
    }
  }
</i18n>
